var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarAddFilled = function SvgCalendarAddFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4H4C2.667 4 2 4.668 2 6.004V8H13.3542C14.0593 7.37764 14.9856 7 16 7C16.7286 7 17.4117 7.19479 18 7.53513V6C18 4.667 17.333 4 16 4H15V2.941C15 2.314 14.667 2 14 2C13.333 2 13 2.314 13 2.941V4H7.004V3C7.004 2.333 6.67 2 6 2C5.33 2 4.998 2.333 5 3V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.126 10H2V20C2 21.333 2.667 22 4 22H12.126C12.0438 21.6804 12 21.3453 12 21V20H11C9.96899 20 9.0291 19.6099 8.31983 18.9693C8.22347 18.9898 8.11686 19 8 19H7C6.333 19.001 6 18.668 6 18C6.001 17.332 6.335 16.999 7.002 17H7.12602C7.04375 16.6804 7 16.3453 7 16C7 15.6547 7.04375 15.3196 7.12602 15H7C6.333 15.001 6 14.668 6 14C6.001 13.332 6.335 12.999 7.002 13H8C8.11686 13 8.22347 13.0102 8.31983 13.0307C9.0291 12.3901 9.96899 12 11 12H12V11C12 10.6547 12.0438 10.3196 12.126 10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11C15 10.4477 15.4477 10 16 10C16.5523 10 17 10.4477 17 11V15H21C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H17V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V17H11C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15H15V11Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarAddFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-add-filled.309f09a3.svg";
export { ForwardRef as ReactComponent };